module.exports = {"350823100":"临江镇","350823101":"临城镇","350823102":"中都镇","350823103":"蓝溪镇","350823104":"稔田镇","350823105":"白砂镇","350823106":"古田镇","350823107":"才溪镇","350823108":"南阳镇","350823109":"蛟洋镇","350823110":"旧县镇","350823111":"湖洋镇","350823112":"溪口镇","350823113":"太拔镇","350823114":"通贤镇","350823115":"下都镇","350823116":"茶地镇","350823202":"庐丰畲族乡","350823206":"泮境乡","350823208":"步云乡","350823211":"官庄畲族乡","350823212":"珊瑚乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350823.json
// module id = 1233
// module chunks = 0